import React from "react";
import { useHistory } from "react-router-dom";

import firebase from "firebaseFactory";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "components/Table";
import { useFirebaseListFunction } from "hooks";
import { UserRole } from "modules/auth";

import { Page } from "../layout/Page";

interface UserDetail {
  uid: string;
  displayName: string;
  email: string;
  photoURL: string;
  role: UserRole;
  siteIds: string[];
}

export const AdminUsersPage = ({
  getUsers = firebase.function("getUsers"),
}) => {
  const history = useHistory();
  const { data: users, isLoading } = useFirebaseListFunction<UserDetail>(
    getUsers
  );
  return (
    <Page isLoading={isLoading}>
      <h2 className="text-xl font-bold leading-tight pt-10 pb-5">Users</h2>
      <Table>
        <TableHead>
          <TableRow>
            <TableHeaderCell>Name</TableHeaderCell>
            <TableHeaderCell>Email address</TableHeaderCell>
            <TableHeaderCell nowrap>Role</TableHeaderCell>
            <TableHeaderCell>Site IDs</TableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {users &&
            users.map((user, index) => (
              <TableRow
                key={index}
                className="cursor-pointer hover:bg-gray-100 align-top"
                onClick={() => {
                  history.push(`/admin/users/edit/${user.uid}`);
                }}
              >
                <TableCell nowrap>
                  {user.photoURL ? (
                    <div>
                      <img
                        className="h-8 w-8 rounded-full inline-block mr-2"
                        src={user.photoURL}
                        alt={user.displayName}
                      />
                      {user.displayName}
                    </div>
                  ) : (
                    <div className="flex flex-row ...">
                      <div>
                        <i className="material-icons h-8 w-8 rounded-full inline-block ml-1 mt-1">
                          person
                        </i>
                      </div>
                      <div className="ml-1 mt-2 ...">{user.displayName}</div>
                    </div>
                  )}
                </TableCell>
                <TableCell className="items-center" nowrap>
                  {user.email}
                </TableCell>
                <TableCell nowrap>{user.role}</TableCell>
                <TableCell>{user.siteIds.join(", ")}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </Page>
  );
};
